import axios from 'axios';


export async function getWorkshopList(payload: any,  mockMode = false) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Workshop/SearchWorkshop`, payload);
        return result;
    }
}

export async function getWorkshopTypeList( mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Workshop/GetWorkshopTypes`,);
        return result;
    }
}

export async function getWorkshopById(id: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Workshop/GetWorkshop/${id}`,);
        return result;
    }
}

export async function deleteWorkshopById(id: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.delete(`/Workshop/DeleteWorkshop/${id}`,);
        return result;
    }
}

export async function deleteJobSeekerById(id: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.delete(`/Workshop/DeleteWorkshopRegistration/${id}`,);
        return result;
    }
}

export async function getRegisteredJobSeekers(workshopId: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Workshop/GetRegisteredJobSeekers/${workshopId}`,);
        return result;
    }
}

export async function saveWorkshop(payload: any, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Workshop/saveWorkshop`,payload);
        return result;
    }
}

export async function bookWorkshop(payload: any, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Workshop/SaveWorkshopRegistration`,payload);
        return result;
    }
}

export async function exportWorkshopRegistrations(workshopId: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.get(`/Workshop/exportWorkshopRegistrations/${workshopId}`,{ responseType: 'arraybuffer'});
        return result;
    }
}

export async function sendNotificationToJobSeekers(workshopId: number, mockMode = false ) {
    const dummyResponse = {
        status: 200,
        data: {
            somethingHere: "no, nothing just test data"
        }
    };
    if (mockMode === true) {
        await new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(null);
            }, 1000);
        });
        return dummyResponse;

    } else {
        let result = await axios.post(`/Workshop/SendNotificationToJobSeekers/${workshopId}`,{});
        return result;
    }
}



